import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getThemeConfig, ShimmerBodyContainer } from '../styles';

var ShimmerBodyText = function ShimmerBodyText(_ref) {
  var _ref$line = _ref.line,
      line = _ref$line === void 0 ? 1 : _ref$line,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["line", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Shimmer',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array(line).fill('').map(function (_, index) {
    return /*#__PURE__*/React.createElement(ShimmerBodyContainer, _extends({
      customTheme: componentTheme
    }, props, {
      key: index
    }));
  }));
};

ShimmerBodyText.displayName = 'ShimmerBodyText';
export default ShimmerBodyText;